module.exports = __webpack_public_path__ + "static/media/flag-bm.7e992c38.webp";